import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import format from '../../helpers/format'
import container from '../../helpers/container'
import {SlideDown} from 'react-slidedown'
import Loader from 'react-loader'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  // AmazonResolutionText,
  // ComcastResolutionText,
  MicrosoftResolutionText,
  CampbellSoupResolutionText,
} from '../../components'
import Styles from './ResolutionLanding.css'


@CSSModules(Styles, {allowMultiple:true})
class ResolutionLandingAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      planId: props.planId
    }
  }

  render() {
    const proxyInfoImg = require('../../../static/images/'+this.state.planId+'-proxy-voting-information.jpg')

    const accordionConfigs = [
      {
        title: 'Vote your own shares',
        content: (
          <div>
            <p>
              Prior to the annual meeting, shareholders are sent documents known as proxy statements that include details about the annual meeting, share ownership, board structure, executive compensation, and details on other issues that will be voted on at the annual meeting. You can cast your ballot by mail, internet, or phone.
            </p>
            <p>
              <b>Mail:</b> If you receive proxy ballots in the mail, follow the instructions on the ballot. The typical process is to either fill out the paper form and mail it back.
            </p>
            <p>
              <b>Email:</b> To find your ballot in your email, try searching “ProxyVote” – this is the service your brokerage will likely use to send you your ballot. See this example of what the email should look like:
            </p>
            <img
              styleName='proxy-ballot-mockup-img'
              src={proxyInfoImg}
              alt='ProxyVote screenshot'
            />
            <p>
              <b>Phone:</b> One you have found your ballot in the mail, or email, there is a number you can call that to vote.
            </p>
            <p>
              Note that companies have the advantage on proxy statements. The company may bury any shareholder resolutions in the back of the document; include only their opinion arguing against the resolution in an “Opposition Statement;” or “summarize” and possibly misrepresent the resolution up front to discourage you from reading it yourself.
            </p>
            <p>
              Be sure to go to the resolution, read it, and decide for yourself. You can also contact the people who put the resolution on the ballot to learn why they think you should vote for it.
            </p>
            <p>
              If you don’t get a ballot for a company you know you own, contact your financial advisor or the company itself about a month before the company’s AGM.
            </p>
          </div>
        )
      },
      {
        title: 'Instruct your financial advisor to vote for you',
        content: (
          <div>
            <p>
              At any time of the year you can instruct your financial advisor to vote on your behalf. Send your advisor a letter that references your accounts and describes how you would like your shares to be voted.
            </p>
            <blockquote styleName='advisor-letter-blockquote'>
              <p>
                Dear <b>[ADVISOR NAME HERE]</b>,
              </p>
              <p>
                Please send me a list of companies I am directly invested in and a report showing how my shares were voted last year. After I have reviewed these, I will instruct you as how to vote on shareholder resolutions, board directors, CEO pay, and auditors going forward. If there is any question or if my voting instructions are unclear, please vote my shares according to the following guidelines:
              </p>
              <p>
                <b>[SHAREHOLDER VOTING PREFERENCES HERE]</b>
              </p>
              <p>
                Sincerely,<br/>
                <b>[SHAREHOLDER NAME]</b>
              </p>
            </blockquote>
            <p>
              <b>PLEASE NOTE:</b> You can make your voting guidelines as simple or complex as you desire. You could simply instruct your advisor to vote against management on every item, or YES on all Environmental, Social, Governance resolutions; or YES on specific issues and NO on others.
            </p>
            <p>
              Knowing the date of last year’s Annual General Meeting (AGM) can give you an idea of when to expect a proxy statement, or when to expect your financial advisor to be in touch with you.
            </p>
            <p>
              Proxy statements usually come out six weeks before the AGM. If you haven’t received a proxy by a month before the company’s AGM, contact your advisor or the company itself. If you elected to get it by email you just click on it and you will see that ballot and also all of your other ones as the control numbers are linked under your name.
            </p>
            <p>
              If your financial advisor tells you they refuse to vote your shares for you, or that it is not part of the services that you have paid for, consider taking your business elsewhere.
            </p>
          </div>
        )
      },
      {
        title: 'Hold your money manager and mutual fund accountable',
        content: (
          <div>
            <p>
              You can’t control how shares in mutual funds are voted – when you invest in a mutual fund, you own a share of the fund, but the fund manager owns the underlying assets.
            </p>
            <p>
              However, you can pressure mutual fund managers to vote for shareholder resolutions. Most financial managers vote with management which is not necessarily in the best interest of shareholders or the company.
            </p>
            <p>
              To help change this, first find out how your mutual funds vote. Consider contacting the financial managers who run the mutual funds you invest in and request their voting record, or their policies on voting shareholder resolutions.
            </p>
            <p>
              Next, ask them to vote for “Environmental, Social, and Governance.” If enough customers make this request, financial companies may begin voting in support of these resolutions that are designed to reduce corporate risk.
            </p>
          </div>
        )
      },
      {
        title: 'See the full resolution',
        content: (
          <div>
            { /*
              this.state.planId === 'amazon-com' ?
                <AmazonResolutionText /> :
                null
            */ }
            { /*
              this.state.planId === 'comcast' ?
                <ComcastResolutionText /> :
                null
            */ }
            {
              this.state.planId === 'microsoft' ?
                <MicrosoftResolutionText /> :
                null
            }
            {
              this.state.planId === 'campbell-soup' ?
                <CampbellSoupResolutionText /> :
                null
            }
          </div>
        )
      }
    ]

    return (
      <div>
        {
          accordionConfigs.map((e, i)=>{
            return (
              <ResolutionLandingAccordionItem
                key={'res-lan-acc-ite-'+i}
                title={e.title}
                content={e.content}
              />
            )
          })
        }
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class ResolutionLandingAccordionItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      title: props.title || 'error',
      content: props.content || null
    }
  }
  render() {
    return (
      <div styleName='acc-wrap'>
        <div
          styleName='acc-button'
          onClick={() => { this.setState({open: !this.state.open}) }}
        >
          <h2>
            <LinkIcon faclass={this.state.open ? 'fa-close' : 'fa-plus'} nospace />
            <b>{this.state.title}</b>
          </h2>
        </div>
        <SlideDown>
          {
            this.state.open ?
              (
                <div styleName='acc-content'>
                  <p>
                    {this.state.content}
                  </p>
                </div>
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class ResolutionLanding extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    if (!this.props.params.planId) {
      this.context.router.push(config.routes.home)
      return (
        <div styleName='page'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const { planId } = this.props.params
    const planData = config.plansSource[planId]

    // kick home if not one of the allowed companies
    // just microsoft and campbell soup for now
    console.log(planId)
    console.log((planId !== 'microsoft' && planId !== 'campbell-soup'))
    if (
      (!planData || !planData.proposal_title)
      || (planId !== 'microsoft' && planId !== 'campbell-soup')
    ) {
      this.context.router.push(config.routes.home)
      return (
        <div styleName='page'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    }

    // const { title, description, url } = this.state
    const title = planData.short_name + ' shareholder resolution'
    const description = `Vote for our shareholder resolution at ${planData.short_name}`
    const url = config.domain + config.routes.resolutionLanding + '/' + planId

    const climateRiskInvestments = format.money(
      planData.screen_results.dff[0] +
        planData.screen_results.dff[1] +
        planData.screen_results.fff[0] +
        planData.screen_results.fff[1],
      true,
      true
    )

    const proposal_number = planData.proposal_title.slice(0,10)

    const headlineImg = require('../../../static/images/vote-yes-checkmark.png')

    const mobileBannerStyle = this.state.mobileBannerFixed ?
      'mobile-fixed' :
      'mobile-relative'

    return (
      <div styleName='page'>
        {
          container.helmet(
            title,
            description,
            url
          )
        }
        <ContainerDivs>

          <div styleName='hl-wrap'>
            { /* LEFT COLUMN */ }
            <div>
              <h1 styleName='hl'>
                {planData.short_name} is investing billions of employee savings in fossil fuels
              </h1>
              <img
                src={headlineImg}
                alt={planData.short_name + ' is investing billions of employee savings in fossil fuels'}
                styleName='hl-img-sm visible-xs'
              />
              <h2 styleName='lede'>
                Vote your shares to reduce climate risk and safeguard employee financial security
              </h2>
              <div styleName='copy'>
                <p>
                  <b>If you own even one share of {planData.short_name}, you have a voice.</b> As a shareholder, you have influence. Most shareholders vote by proxy, which is the ballot containing all matters being put to a vote by the corporation. It includes board directors, CEO pay, as well as shareholder resolutions about environmental, governance, and social issues critical to the company’s business practices.
                </p>
                <p styleName='scroll-link'>
                  <ScrollLink
                    activeClass='active-scroll-link'
                    to='section1'
                    spy
                    smooth
                    offset={-70}
                    duration={500}
                  >
                    <b>Join <i>As You Sow</i> by voting YES on {proposal_number} on your {planData.short_name} shareholder ballot.</b>
                  </ScrollLink>
                </p>
                <div styleName='hidden-xs'>
                  <p>
                    This year, you can vote to ask {planData.short_name}:  Why is the company saying “{planData.climate_claim},” and at the same time directing {climateRiskInvestments} of employee savings into investments with climate risk like fossil fuels and deforestation-risk agribusiness?
                  </p>
                  <p>
                    Use the “vote now” link to support our resolution. You can also submit questions asking the company what they are doing to reduce climate risk in the company 401(k) plan.
                  </p>
                  <p styleName='scroll-link'>
                    <ScrollLink
                      activeClass='active-scroll-link'
                      to='section1'
                      spy
                      smooth
                      offset={-70}
                      duration={500}
                    >
                      <b>Vote YES on {planData.proposal_title}.</b>
                    </ScrollLink>
                  </p>
                  <ResolutionLandingAccordion planId={planId}/>
                </div>

                { /* AFTER PETITION LINKS */ }
                <div styleName='after-petition-links hidden-xs'>
                  <div styleName='after-petition-links-lbl'>
                    More
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.plans + '/' + planId}
                      title={planData.plan_short_name+' scorecard'}
                      xstrong
                    >
                      {planData.short_name} retirement plan scorecard<LinkIcon/>
                    </Link>
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.eduCenter}
                      title='Five steps to a sustainable retirement plan'
                      xstrong
                    >
                      Five steps to a sustainable retirement plan<LinkIcon/>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            { /* RIGHT COLUMN */ }
            <div styleName='hl-img-wrap'>
              <div styleName='petition-widget-wrap'>
                <img
                  src={headlineImg}
                  alt={planData.short_name+' investors: Vote YES on shareholder proposal '+proposal_number}
                  styleName='hl-img hidden-xs'
                />
                <div styleName={'sticky-widget ' + mobileBannerStyle}>
                  <div id='section1'/>
                  <div styleName='sticky-widget-close visible-xs'>
                    <div
                      onClick={
                        () => {
                          //
                          this.setState({
                            mobileBannerFixed: false
                          })
                        }
                      }
                    >
                      <LinkIcon nospace faclass='fa-close'/>
                    </div>
                  </div>
                  <h2 styleName='thumbs-up-top-label'>
                    {planData.short_name+' investors: Vote YES on shareholder proposal '+proposal_number}
                  </h2>
                  <div styleName='c'>
                    <h3 styleName='thumbs-up-top-label-2'>
                      Have your control number?
                    </h3>
                  </div>

                  <div styleName='c'>
                    <button>
                      <Link
                        to={config.links.proxyvote}
                        title='Vote your proxy now with your control number'
                        primarybutton
                      >
                        <div styleName='sidebar-button'>
                          Vote Now<LinkIcon/>
                        </div>
                      </Link>
                    </button>
                  </div>

                  <br/>

                  <div styleName='hidden-xs'>
                    <div styleName='c'>
                      <h3 styleName='thumbs-up-top-label-2'>
                        {planData.plan_short_name} scorecard
                      </h3>
                    </div>

                    <div styleName='c'>
                      <button>
                        <Link
                          to={config.routes.plans + '/' + planId}
                          title='Scorecard'
                          orangebutton
                          targetBlank
                        >
                          <div styleName='sidebar-button'>
                            Scorecard<LinkIcon/>
                          </div>
                        </Link>
                      </button>
                    </div>

                    <br/>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div styleName='visible-xs'>
            <div
              styleName='show-more-button'
              title='Learn more'
              onClick={
                (e)=>{
                  this.setState({showFullPetition: !this.state.showFullPetition})
                }
              }
            >
              Learn more<LinkIcon faclass={
                this.state.showFullPetition ?
                  'fa-angle-double-up' :
                  'fa-angle-double-down'
              }/>
            </div>
            <SlideDown>
              {
                this.state.showFullPetition ?
                  (
                    <div styleName='copy'>
                      <p>
                        This year, you can vote to ask {planData.short_name}:  Why is the company saying “{planData.climate_claim},” and at the same time directing {climateRiskInvestments} of employee savings into fossil fuels and rainforest destruction?
                      </p>
                      <p>
                        Leverage your power as a shareholder by <b>Voting YES on {planData.proposal_title}.</b>
                      </p>
                      <p styleName='scroll-link'>
                        <ScrollLink
                          activeClass='active-scroll-link'
                          to='section1'
                          spy
                          smooth
                          offset={-70}
                          duration={500}
                        >
                          <b>Join lorem.</b>
                        </ScrollLink>
                      </p>

                      <ResolutionLandingAccordion planId={planId}/>
                    </div>
                  ) :
                  null
              }
            </SlideDown>
          </div>

          { /* AFTER PETITION LINKS */ }
          <div styleName='after-petition-links visible-xs'>
            <div styleName='after-petition-links-lbl'>
              More
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.plans + '/' + planId}
                title={planData.plan_short_name+' scorecard'}
                xstrong
              >
                {planData.short_name} retirement plan scorecard<LinkIcon/>
              </Link>
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.eduCenter}
                title='Five steps to a sustainable retirement plan'
                xstrong
              >
                Five steps to a sustainable retirement plan<LinkIcon/>
              </Link>
            </div>
          </div>

        </ContainerDivs>

        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}
